<template>
  <div class="page-shell">
    <div class="topbar">
      <div class="page-title"><h1>🎙️ 主播管理</h1><p>管理所有主播信息（个人主播 & MCN旗下主播）</p></div>
    </div>

    <div class="card">
      <div class="search-bar">
        <input v-model.trim="draftFilters.name" type="text" placeholder="搜索主播姓名..." @keyup.enter="applySearch">
        <select v-model="draftFilters.type">
          <option value="">全部类型</option>
          <option value="individual">个人主播</option>
          <option value="mcn">MCN旗下主播</option>
        </select>
        <button class="btn btn-outline" @click="applySearch">
          <span>🔍</span>
          <span>查询</span>
        </button>
      </div>
      <div class="table-wrap">
        <table>
          <thead><tr><th>ID</th><th>主播编号</th><th>姓名</th><th>手机号</th><th>身份类型</th><th>归属</th><th>状态</th><th>主播类型</th><th>粉丝</th><th>平台数</th><th>近一年利润</th><th>授权状态</th><th>创建时间</th><th>操作</th></tr></thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="14" class="table-empty">加载中...</td>
            </tr>
            <tr v-else-if="!list.length">
              <td colspan="14" class="table-empty">暂无主播记录</td>
            </tr>
            <template v-else>
              <tr v-for="item in list" :key="item.id">
                <td>{{ item.id }}</td>
                <td>{{ item.accountNo }}</td>
                <td><strong>{{ item.name }}</strong></td>
                <td>{{ item.phone }}</td>
                <td><span :class="['tag', item.type === 'mcn' ? 'tag-purple' : 'tag-blue']">{{ item.typeText }}</span></td>
                <td>{{ item.ownershipText }}</td>
                <td><span :class="statusClass(item.status)">{{ item.statusText }}</span></td>
                <td>{{ item.streamerType }}</td>
                <td style="color:var(--cog-primary);font-weight:600">{{ item.fansText }}</td>
                <td>{{ item.platformCount }}</td>
                <td>{{ item.lastYearProfit }}</td>
                <td><span :class="statusClass(item.authorizationStatus, 'none')">{{ item.authorizationStatusText }}</span></td>
                <td>{{ item.createdAt }}</td>
                <td><button class="btn btn-sm btn-outline" @click="openDetail(item)">查看详情</button></td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <div class="anchor-pagination">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :current-page="pagination.currentPage"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @current-change="handlePageChange"
        />
      </div>
    </div>

    <el-dialog :title="detailTitle" :visible.sync="detailDialog" width="820px">
      <div v-if="detailLoading" class="dialog-state">加载中...</div>
      <div v-else-if="currentAnchor">
        <div class="detail-section">
          <h4>📋 主播基本信息</h4>
          <div class="info-grid">
            <div v-for="field in detailFields" :key="field.label" class="info-item">
              <span class="ii-label">{{ field.label }}</span>
              <span class="ii-value">{{ field.value }}</span>
            </div>
          </div>
        </div>
        <div class="detail-section">
          <h4>📱 主播账号列表信息</h4>
          <div class="table-wrap">
            <table>
              <thead><tr><th>平台</th><th>昵称</th><th>平台账号ID</th><th>垂类赛道</th><th>粉丝数</th></tr></thead>
              <tbody>
                <tr v-if="!currentAnchor.platformAccounts.length">
                  <td colspan="5" class="table-empty">暂无主播账号信息</td>
                </tr>
                <tr v-for="account in currentAnchor.platformAccounts" :key="account.id">
                  <td>{{ account.platformText }}</td>
                  <td>{{ account.nickname }}</td>
                  <td>{{ account.platformId }}</td>
                  <td>{{ account.verticalTrackText }}</td>
                  <td>{{ account.fansCount }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div v-else class="dialog-state">未找到主播详情</div>
    </el-dialog>
  </div>
</template>

<script>
import {
  streamerProfilesList,
  streamerProfileDetail
} from '../../api/userMG'

export default {
  name: 'anchor-index',
  data() {
    return {
      loading: false,
      detailLoading: false,
      list: [],
      filters: { name: '', type: '' },
      draftFilters: { name: '', type: '' },
      pagination: {
        currentPage: 1,
        pageSize: 15,
        total: 0,
        lastPage: 1
      },
      detailDialog: false,
      currentAnchor: null
    }
  },
  computed: {
    detailTitle() {
      return this.currentAnchor ? '主播详情 - ' + this.currentAnchor.name : '主播详情'
    },
    detailFields() {
      if (!this.currentAnchor) return []

      return [
        { label: '主播ID', value: this.currentAnchor.id },
        { label: '主播编号', value: this.currentAnchor.accountNo },
        { label: '姓名', value: this.currentAnchor.name },
        { label: '手机号', value: this.currentAnchor.phone },
        { label: '身份类型', value: this.currentAnchor.typeText },
        { label: '归属', value: this.currentAnchor.ownershipText },
        { label: '状态', value: this.currentAnchor.statusText },
        { label: '主播类型', value: this.currentAnchor.streamerType },
        { label: '粉丝数', value: this.currentAnchor.fansText },
        { label: '平台数', value: this.currentAnchor.platformCount },
        { label: '近一年利润', value: this.currentAnchor.lastYearProfit },
        { label: '授权状态', value: this.currentAnchor.authorizationStatusText },
        { label: '身份证号', value: this.currentAnchor.idCardNo },
        { label: '创建时间', value: this.currentAnchor.createdAt }
      ]
    }
  },
  created() {
    this.loadList(1)
  },
  methods: {
    async loadList(page) {
      this.loading = true

      const targetPage = page || this.pagination.currentPage
      const params = {
        page: targetPage,
        per_page: this.pagination.pageSize
      }

      if (this.filters.name) {
        params.name = this.filters.name
      }

      if (this.filters.type) {
        params.type = this.filters.type
      }

      try {
        const res = await streamerProfilesList(params)

        if (!this.isListSuccess(res)) {
          this.list = []
          this.pagination.total = 0
          this.$message.error(this.getErrorMessage(res, '主播列表加载失败'))
          return
        }

        const meta = res.meta || {}

        this.list = Array.isArray(res.data) ? res.data.map(item => this.normalizeAnchor(item)) : []
        this.pagination.currentPage = Number(meta.current_page) || targetPage
        this.pagination.pageSize = Number(meta.per_page) || this.pagination.pageSize
        this.pagination.total = Number(meta.total) || 0
        this.pagination.lastPage = Number(meta.last_page) || 1
      } catch (error) {
        this.list = []
        this.pagination.total = 0
        this.$message.error(this.getErrorMessage(error, '主播列表加载失败'))
      } finally {
        this.loading = false
      }
    },
    normalizeAnchor(item) {
      const status = item.status || this.inferStatusByText(item.status_text)
      const authorizationStatus = item.authorization_status || this.inferAuthorizationStatusByText(item.authorization_status_text)

      return {
        id: item.id,
        accountNo: item.account_no || '—',
        name: item.name || '—',
        phone: item.phone || '—',
        type: item.type || '',
        typeText: this.typeText(item.type),
        ownershipText: item.ownership_text || '—',
        status,
        statusText: item.status_text || '—',
        streamerType: item.streamer_type || '—',
        fansText: item.fans_text || '—',
        platformCount: Number(item.platform_count) || 0,
        lastYearProfit: item.last_year_profit || '—',
        authorizationStatus,
        authorizationStatusText: item.authorization_status_text || '—',
        idCardNo: item.id_card_no || '—',
        createdAt: item.created_at || '—',
        platformAccounts: Array.isArray(item.platform_accounts)
          ? item.platform_accounts.map(account => this.normalizePlatformAccount(account))
          : []
      }
    },
    normalizePlatformAccount(account) {
      return {
        id: account.id,
        platform: account.platform || '',
        platformText: account.platform_text || '—',
        verticalTrack: account.vertical_track || '',
        verticalTrackText: account.vertical_track_text || '—',
        platformId: account.platform_id || '—',
        fansCount: account.fans_count || '—',
        nickname: account.nickname || '—'
      }
    },
    extractDetail(res) {
      if (!res || typeof res !== 'object' || res.message || res.detail || res.errors) {
        return null
      }

      if (res.data && !Array.isArray(res.data) && typeof res.data === 'object') {
        return res.data
      }

      return res
    },
    isListSuccess(res) {
      return !!(res && typeof res === 'object' && Array.isArray(res.data) && res.meta && !res.message && !res.detail && !res.errors)
    },
    typeText(type) {
      return {
        individual: '个人主播',
        mcn: 'MCN旗下主播'
      }[type] || type || '—'
    },
    inferStatusByText(text) {
      return {
        '正常': 'normal',
        '已禁用': 'disabled',
        '已删除': 'deleted'
      }[text] || ''
    },
    inferAuthorizationStatusByText(text) {
      return {
        '已授权': 'authorized',
        '待授权': 'pending',
        '已过期': 'expired'
      }[text] || 'none'
    },
    statusClass(status, emptyStatus) {
      return {
        status: true,
        'status-pending': status === 'pending',
        'status-approved': status === 'approved' || status === 'normal' || status === 'authorized',
        'status-rejected': status === 'rejected' || status === 'expired' || status === 'disabled' || status === 'deleted',
        'status-none': !status || status === emptyStatus
      }
    },
    getErrorMessage(error, fallback) {
      if (!error) return fallback
      if (typeof error === 'string') return error
      if (error.message) return error.message
      if (error.detail) return error.detail
      if (error.errors) {
        const firstKey = Object.keys(error.errors)[0]
        const firstError = firstKey ? error.errors[firstKey] : ''

        if (Array.isArray(firstError)) {
          return firstError[0] || fallback
        }

        return firstError || fallback
      }

      return fallback
    },
    applySearch() {
      this.filters = Object.assign({}, this.draftFilters)
      this.pagination.currentPage = 1
      this.loadList(1)
    },
    handlePageChange(page) {
      this.loadList(page)
    },
    async openDetail(item) {
      this.detailDialog = true
      this.detailLoading = true
      this.currentAnchor = null

      try {
        const res = await streamerProfileDetail(item.id)
        const detail = this.extractDetail(res)

        if (!detail || !detail.id) {
          this.$message.error(this.getErrorMessage(res, '主播详情加载失败'))
          this.detailDialog = false
          return
        }

        this.currentAnchor = this.normalizeAnchor(detail)
      } catch (error) {
        this.$message.error(this.getErrorMessage(error, '主播详情加载失败'))
        this.detailDialog = false
      } finally {
        this.detailLoading = false
      }
    }
  }
}
</script>

<style scoped>
.anchor-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
}

.dialog-state {
  padding: 32px 0;
  text-align: center;
  color: #64748b;
}

.detail-section + .detail-section {
  margin-top: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/anchor/index.vue